<template>
    <div class="bg-surface-0 dark:bg-surface-950 px-6 py-20 md:px-12 lg:px-20">
        <div class="mb-4 w-full flex">
            <StaticImage class="datalaneLogo" filename="pac-logo.svg" />
        </div>

        <div class="flex flex-col lg:flex-row justify-center items-center gap-16">
            <div class="text-center lg:text-right">
                <div class="mt-12 mb-4 font-bold text-6xl text-surface-900 dark:text-surface-0">Connection lost</div>
                <p class="text-surface-700 dark:text-surface-100 text-3xl mt-0 mb-12">Please check your connection and try again.</p>
                <p class="text-surface-700 dark:text-surface-100 text-1xl mt-0 mb-12 supportText">If you are sure that your connection is working, the DataLane Portal might be down.
                    Try again in a few minutes, otherwise contact DataLane Support.</p>
                <Button rounded label="Reload application" @click="reload"></Button>
            </div>
            <div>
                <i class="pi pi-wifi connIcon" />
            </div>
        </div>
    </div>
</template>
<script setup>
import {useRouter} from "vue-router";
import { onMounted } from "vue";
import {useStore} from "vuex";
import {ROUTE_NAMES} from "@/src/router";
import {useLastApiError} from "@/src/queries/errors";

const store = useStore()
const router = useRouter()

const error = useLastApiError()

onMounted(() => {
    if (!error.value || error.value.code !== 'ERR_NETWORK') {
        //someone tried to enter offline page by typing the url instead of automatically trigger from network error
        reload()
    }
})

const reload = () => router.push({name: ROUTE_NAMES.HOME})
</script>
<style scoped>
.connIcon {
    font-size: 250px;
}
.supportText {
    max-width: 530px;
}
.datalaneLogo {
    margin:auto;
}
</style>